import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Checkbox, Grid, Space, Typography } from "antd";
import React, { ReactNode, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { MasterArticleCategoryProperties, MasterArticleSubCategoryProperties } from "../../../../types/blog.type";

export interface Option extends MasterArticleCategoryProperties {
	label: string;
}

const { Text } = Typography;
export default function SelectCategories({
	categories,
	onSelectCategoryId,
	onSelectParentCategoryId,
	value,
	parentCategoryWatch,
}: {
	categories: MasterArticleCategoryProperties[];
	onSelectCategoryId: (categoryId: string[]) => void;
	onSelectParentCategoryId: (parentCategoryId: string[]) => void;
	value?: string[];
	parentCategoryWatch: string[] | undefined;
}) {
	const [selectedParentCategory, setSelectedParentCategory] = useState<string | undefined>(undefined);
	const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
	const [selectedParentCategories, setSelectedParentCategories] = useState<string[]>([]);

	const { md, lg, sm } = Grid.useBreakpoint();

	useEffect(() => {
		// if (selectedCategories.length > 0) {
		// 	// const categoryIds = selectedCategories.map((catId) => catId?.split("_")[1]);
		// 	onSelectCategoryId(selectedCategories);
		// }
		// onSelectCategoryId(selectedCategories);
	}, [selectedCategories]);

	useEffect(() => {
		if (value) {
			setSelectedCategories(value);
		}
		if (parentCategoryWatch) {
			setSelectedParentCategories(parentCategoryWatch);
		}
	}, [value, parentCategoryWatch]);

	const CascaderMenu = ({
		category,
		onClick,
		children,
	}: {
		category?: MasterArticleSubCategoryProperties | MasterArticleCategoryProperties;
		onClick?: () => void;
		children?: ReactNode;
	}) => {
		const parentCategory = category as MasterArticleCategoryProperties;
		const subCategory = category as MasterArticleSubCategoryProperties;

		const isParent = parentCategory?.hasOwnProperty("subCategories");
		const isDisabled = isParent && parentCategory?.subCategories.length === 0;
		const isSelected =
			selectedCategories.includes(`${subCategory?.parentCategoryId}_${subCategory?.categoryId}`) ||
			selectedParentCategories.includes(parentCategory?.categoryId);
		const isSelectedMenu = false;

		let selectedSubCategoryLengthGroupByParentId =
			selectedCategories &&
			selectedCategories.length > 0 &&
			selectedCategories.reduce((acc: any, item) => {
				let parentId = item?.split("_")[0];
				acc[parentId] = (acc[parentId] || 0) + 1;
				return acc;
			}, {});
		const isParentSelected = isParent && category?.categoryId === selectedParentCategory;

		if (children)
			return (
				<div
					style={{
						display: "grid",
						placeItems: "center",
						height: "100%",
					}}
				>
					{children}
				</div>
			);

		return (
			<div
				className={`cascader-menu ${isSelected || isSelectedMenu ? "cascader-active" : ""}`}
				onClick={() => {
					// if (isDisabled) return;

					onClick?.();
				}}
			>
				<div className="cascader-label">
					<Space>
						{isParent && (
							<>
								{sm ? (
									parentCategory?.subCategories.length === 0 ? (
										<></>
									) : selectedParentCategory === category?.categoryId ? (
										<MinusOutlined
											style={{
												fontSize: sm ? 14 : md ? 16 : 10,
												color: "#000",
											}}
										/>
									) : (
										<PlusOutlined
											style={{
												fontSize: sm ? 14 : md ? 16 : 10,
												color: "#A1A1AA",
											}}
										/>
									)
								) : null}
								<Text className="count">
									({selectedSubCategoryLengthGroupByParentId[`${category?.categoryId}`] ?? 0}/
									{parentCategory?.subCategories.length})
								</Text>
							</>
						)}

						<div
							style={{
								display: "flex",
								flexDirection: "column",
							}}
						>
							<Text className="menu">{category?.categoryName}</Text>
						</div>
					</Space>
					<Checkbox
						// disabled={isDisabled}
						// indeterminate={
						// 	(!isDisabled && isParentSelected) ||
						// 	selectedSubCategoryLengthGroupByParentId[`${category?.categoryId}`] === 0
						// }
						checked={isSelected || selectedSubCategoryLengthGroupByParentId[`${category?.categoryId}`] > 0}
					/>
				</div>
			</div>
		);
	};

	const subCategories = useMemo(() => {
		if (!selectedParentCategory) return;
		const res = categories.find((cat) => cat.categoryId === selectedParentCategory)?.subCategories;

		return res;
	}, [categories, selectedParentCategory]);

	return (
		<ContainerCascader>
			{categories.length === 0 ? (
				<CascaderCustom>
					<CascaderMenu>
						<div
							style={{
								fontSize: 12,
								color: "#9B9B9B",
								textAlign: "center",
							}}
						>
							Category is Empty, Please add category first.
						</div>
					</CascaderMenu>
				</CascaderCustom>
			) : (
				<>
					<CascaderCustom>
						{categories.map((category) => (
							<div key={category.categoryId}>
								<CascaderMenu
									category={category}
									onClick={() => {
										if (category.subCategories?.length === 0) {
											console.log("choose category");
											const idExist = selectedParentCategories.find(
												(v) => v === category.categoryId
											);
											if (idExist) {
												const newIds = selectedParentCategories.filter(
													(v) => v !== category.categoryId
												);

												setSelectedParentCategories(newIds);
												onSelectParentCategoryId(newIds);
											} else {
												setSelectedParentCategories([
													...selectedParentCategories,
													category.categoryId,
												]);
												onSelectParentCategoryId([
													...selectedParentCategories,
													category.categoryId,
												]);
											}

											setSelectedParentCategory(category.categoryId);
										} else if (category.categoryId === selectedParentCategory) {
											setSelectedParentCategory(undefined);
										} else {
											setSelectedParentCategory(category.categoryId);
										}
									}}
								/>
							</div>
						))}
					</CascaderCustom>
					<CascaderCustom>
						{subCategories && subCategories?.length > 0
							? subCategories.map((category) => (
									<div key={category.categoryId}>
										<CascaderMenu
											category={category}
											onClick={() => {
												if (
													selectedCategories.includes(
														`${category.parentCategoryId}_${category.categoryId}`
													)
												) {
													const newSelectedCategories = selectedCategories.filter(
														(v) =>
															v !== `${category.parentCategoryId}_${category.categoryId}`
													);
													setSelectedCategories(newSelectedCategories);
													onSelectCategoryId(newSelectedCategories);
												} else {
													setSelectedCategories([
														...selectedCategories,
														`${category.parentCategoryId}_${category.categoryId}`,
													]);
													onSelectCategoryId([
														...selectedCategories,
														`${category.parentCategoryId}_${category.categoryId}`,
													]);
												}
											}}
										/>
									</div>
							  ))
							: null}
					</CascaderCustom>
				</>
			)}
		</ContainerCascader>
	);
}

const ContainerCascader = styled.div`
	width: 100%;
	display: flex;
	border: 1px solid #d4d4d8;

	@media screen and (min-width: 991px) {
		width: 70%;
	}
`;

const CascaderCustom = styled.div`
	width: calc(100% / 2);
	height: calc(66px * 5);
	overflow-y: scroll;

	::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 8px;
		border-right: 1px solid #d4d4d8;
		border-left: 1px solid #d4d4d8;
	}

	::-webkit-scrollbar-thumb {
		background: #d9d9d9;
		box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
	}

	.cascader-menu {
		padding: 0px 12px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
		border-bottom: 1px solid #f4f4f5;
		height: 66px;

		.cascader-label {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
		}
		.count {
			color: #a1a1aa;
			letter-spacing: 1px;
			font-size: 14px;
		}

		.menu {
			font-size: 14px;
		}

		.selected-menu {
			color: #b1b6b9;
			font-size: 12px;
		}

		&.cascader-active {
			background-color: #eaeaea;
		}

		&.cascader-disabled {
			background-color: #d9d8d8;
			cursor: not-allowed;
		}

		@media screen and (max-width: 768px) {
			.menu,
			.count {
				font-size: 12px !important;
			}
		}

		@media screen and (max-width: 576px) {
			.menu,
			.count {
				font-size: 10px !important;
			}
		}
	}
`;
